import { Avatar, AvatarProps, Box, styled } from "@mui/material";
import { memo } from "react";
import AIAgentBorder from "./AIAgentBorder";

const AIAgentAvatarInner = styled(Avatar)<AvatarProps>(() => ({
  borderRadius: 0,
  clipPath: 'polygon(50% 0%, 95% 25%, 95% 75%, 50% 100%, 5% 75%, 5% 25%)',
}));

const AIAgentAvatar: React.FC<AvatarProps> = (props) => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <AIAgentAvatarInner {...props}
        slotProps={{
          img: {
            loading: 'lazy',
          }
        }}
      />
      <AIAgentBorder />
    </Box>
  )
}

export default memo(AIAgentAvatar);
